/* eslint arrow-body-style: 0 */
import ConversationView from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';
import store from '../../../../store';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/pipelines'),
      beforeEnter: async (to, from, next) => {
        const { accountId } = to.params;
        let boardId = localStorage.getItem(`selectedboard_${accountId}`);
        if (boardId===null) {
          await store.dispatch('pipelines/getBoards');
          const boards = store.getters['pipelines/getAllBoards'];
          console.log('debugger  method executed', boards);
          boardId = boards.length > 0 ? boards[0].id : '1';
          localStorage.setItem(`selectedboard_${accountId}`, boardId);
        }
        next(frontendURL(`accounts/${accountId}/pipelines/boards/${boardId}`));
      },
      name: 'pipeline',
      roles: ['administrator', 'agent'],
      component: ConversationView,
      props: () => {
        return { inboxId: 0 };
      },
    },
    {
      path: frontendURL('accounts/:accountId/pipelines/boards/:board_id'),
      beforeEnter:async (to, from, next) => {
        const { accountId, board_id } = to.params;
        await store.dispatch('pipelines/getBoards');
        const boards = store.getters['pipelines/getAllBoards'];
        const found = boards.some(board => String(board.id) === String(board_id));
        if (found) {
          next();
        } else {
          if(boards.length > 0){
            alert('Board not found and will redirect to Default Board');
            const boardId = boards[boards.length -1].id;
            localStorage.setItem(`selectedboard_${accountId}`, boardId);
            next(frontendURL(`accounts/${accountId}/pipelines/boards/${boardId}`));
          }else{
            alert('No board found, create a board first');
            next(frontendURL(`accounts/${accountId}/settings/board`));
          }
        }
      },
      name: 'pipeline_boards',
      roles: ['administrator', 'agent'],
      component: ConversationView,
      props: (route) => {
        
        return {board_id: route.params.board_id};
      },
    },
    {
      path: frontendURL(
        'accounts/:accountId/pipelines/boards/:board_id/custom_view/:id'
      ),
      name: 'pipeline_custom_view',
      roles: ['administrator', 'agent'],
      component: ConversationView,
      beforeEnter: async (to, from, next) => {
        const { accountId, board_id } = to.params;
        // Get the current board_id from param or localStorage or use first board
        let boardId = board_id || localStorage.getItem(`selectedboard_${accountId}`);
        if (!boardId) {
          await store.dispatch('pipelines/getBoards');
          const boards = store.getters['pipelines/getAllBoards'];
          boardId = boards.length > 0 ? boards[0].id : '1';
        }
        localStorage.setItem(`selectedboard_${accountId}`, String(boardId));
        next();
      },
      props: route => {
        return {
          board_id: route.params.board_id,
          boardFilterId: route.params.id,
        };
      },
    },
    {
      path: frontendURL('accounts/:accountId/pipelines/custom_view/:id'),
      name: 'pipeline_custom_view_legacy',
      roles: ['administrator', 'agent'],
      beforeEnter: async (to, from, next) => {
        const { accountId, id } = to.params;
        const boardId =
          to.query.board_id ||
          localStorage.getItem(`selectedboard_${accountId}`) ||
          '1';
        next(
          frontendURL(
            `accounts/${accountId}/pipelines/boards/${boardId}/custom_view/${id}`
          )
        );
      },
    },
  ],
};
